const BASE_URL = '/api/collections/cases/entries?limit=1000';
import { stopScrolling, startScrolling, } from '../alpine-functions';

export default () => ({
  cases: [],
  filteredCases: [],
  query: '',
  open: false,
  fuseOptions: {
    keys: ['title', 'politicians'],
    shouldSort: true,
    minMatchCharLength: 2,
    threshold: 0.4,
  },

  init() {
    fetch(BASE_URL)
    .then(response => response.json())
    .then((response) => {
        this.cases = response.data;
    });
  },

  searchQuery() {
    if (this.query.length > 0) {
        const fuse = new Fuse(this.cases, this.fuseOptions);
        const result = fuse.search(this.query);
        this.filteredCases = result;
    }
  },

  caseInfluence(item) {
    var influence = "";
    if (item.russian_influence) {
        influence = "cases__item--russian"
    }
    if (item.russian_positive_influence) {
        influence += " cases__item--russian-positive"
    }
    if (item.chinese_influence) {
        influence += " cases__item--chinese"
    }
    if (item.chinese_positive_influence) {
        influence += " cases__item--chinese-positive"
    }
    return influence;
  },

  parseExcerpt(excerpt) {
    //console.log(excerpt[0].content);
    if(excerpt) {
        let ret = excerpt[0].content.map((function(item) {
            if (item['text']) {
                return item['text'];
            }
        }))
        return ret.join("");
    }
  },

  openSearchModal() {
    this.open = true;
    this.clearSearch();
    this.setFocus();
    stopScrolling();
  },

  closeSearchModal() {
    this.open = false;
    this.clearSearch();
    startScrolling();
  },

  clearSearch() {
    this.query = '';
    this.filteredCases = [];
  },

  setFocus() {
    setTimeout(() => {
      const inputs = document.querySelectorAll('.search-results__search__input');
      inputs.forEach((input) => {
        if (window.innerWidth < 576 && input.classList.contains('input-small')) {
            input.focus()
        }
        else if (window.innerWidth >= 576 && input.classList.contains('input-big')) {
            input.focus()
        }
      })
    }, 100);
  },
});
